var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessagesv2 = function SvgMessagesv2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.078,
    d: "M3.592 8.62A3.592 3.592 0 0 1 8.62 13.65M3.592 8.62a3.59 3.59 0 0 0-1.276 3.939c.196.632.055 1.336-.07 2a.336.336 0 0 0 .424.387c.61-.167 1.215-.309 1.837-.08a3.59 3.59 0 0 0 4.113-1.217M3.592 8.62c0-3.365 2.065-6.465 5.747-6.465a5.747 5.747 0 0 1 5.41 7.686c-.342.953.027 2.229.242 3.282a.325.325 0 0 1-.42.378c-.942-.295-2.048-.709-2.934-.335-.958.403-1.965.482-3.017.482"
  })));
};
export default SvgMessagesv2;